import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    defaultconfigurations: []
};

export const defaultConfigSlice = createSlice({
    name: 'defaultConfigSlice',
    initialState,
    reducers: {
       
        getAllDefaultConfig: (state, action) => {
            state.defaultconfigurations = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { getAllDefaultConfig} = defaultConfigSlice.actions;

export default defaultConfigSlice.reducer;
